import { RiskKeys } from '@/config';
import getRiskGroupBySignal from './getRiskGroupBySignal';

type AntdTagColor = 'green' | 'orange' | 'red' | undefined;

export function getRiskColorForTag(signal: RiskKeys | string): AntdTagColor {
  const group = getRiskGroupBySignal(signal as RiskKeys);
  if (group === 'trusted') return 'green';
  if (group === 'suspicious') return 'orange';
  if (group === 'danger') return 'red';
  return undefined;
}
